/**
 * Site — top-level site metadata. The full editable shape is in
 * SiteDoc; this struct is the "header" subset (everything that lives
 * in `site.json` on push, minus the edges which are also there but
 * carry their own schema).
 */
import * as Schema from "effect/Schema";

import { DocumentSiteId } from "./ids.js";
import { SiteThemeOrLegacy } from "./theme.js";

/** Site-wide navigation settings. `nested` opts the published menu into the
 *  hierarchical (parent → submenu children) renderer; absent/false keeps the
 *  original flat menu, so existing sites are unaffected. */
export const SiteNav = Schema.Struct({
  nested: Schema.optional(Schema.Boolean),
});
export type SiteNav = Schema.Schema.Type<typeof SiteNav>;

export const Site = Schema.Struct({
  id: DocumentSiteId,
  name: Schema.String.pipe(Schema.minLength(1)),
  description: Schema.optional(Schema.String),
  theme: SiteThemeOrLegacy,
  nav: Schema.optional(SiteNav),
});
export type Site = Schema.Schema.Type<typeof Site>;
